import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel, EditPageTextArea } from './../../../common/EditPage';
import { create, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const AiAgentsCreate = () => {
    const [data, setData] = useState({ status: true });
    const [metadata, setMetadata] = useState({});
    const [languages, setLanguages] = useState({});
    const navigate = useNavigate();
    useEffect(() => {
        getOne('/admin/ai/agents/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, []);

    // Load languages when voice is selected
    useEffect(() => {
        if (data.voice_id) {
            getOne('/admin/ai/agents/voice/', `${data.voice_id}/languages`)
                .then(response => {
                    if (response.data.result === 'OK') {
                        setLanguages(response.data.data.languages);
                    }
                })
                .catch(error => {
                    console.error('Error loading languages:', error);
                    setLanguages({});
                });
        } else {
            setLanguages({});
        }
    }, [data.voice_id]);

    const handleSave = () => {
        create('/admin/ai/agents', {data: data}).then(response => {
            toast.success("AI Agent created successfully", {});
            navigate('/ai/agents');
        }).catch(error => {
            toast.error("Error creating AI Agent: " + error.message, {});
        });
    }
    const handleCancel = () => {
        navigate('/ai/agents');
    }
    const onChange = (id, value) => {
        // Clear language when voice changes
        if (id === 'voice_id') {
            setData({ ...data, [id]: value, language: undefined });
        } else {
            setData({ ...data, [id]: value });
        }
    }
    
    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title="Create AI Agent" >
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageTextArea label="Backstory" id="backstory" onChange={ onChange } value={ data.backstory } rows={ 40 } />
                    <EditPageCheckbox label="Enabled" id="status" onChange={ onChange } value={ data.status } />
                </EditPagePanel>
                <EditPagePanel className="col-lg-4">
                    <EditPageSelect label="Voice" id="voice_id" onChange={ onChange } value={ data.voice_id } options={ metadata?.voices } />
                    <EditPageSelect label="Language" id="language" onChange={ onChange } value={ data.language } options={ languages } disabled={ !data.voice_id } />
                    <EditPageSelect label="Speech Style" id="speech_style_id" onChange={ onChange } value={ data.speech_style_id } options={ metadata?.speech_style_id } />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default AiAgentsCreate;